import { Grid2, Typography, IconButton } from "@mui/material";
import PeopleAltIcon from "@mui/icons-material/PeopleAlt";
import WorkHistoryIcon from "@mui/icons-material/WorkHistory";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import DashboardLayout from "../../../layoutcontainers/DashboardLayout";
import CustomCalendar from "./components/HolidayWeekoffCalendar";
import SimpleBranchBar from "./components/BranchOverview";
import { useEffect, useState } from "react";
import BASEURL from "../../Utils/Baseurl";
import axios from "axios";
import { useLoading } from "../../../context/loading";

export default function DashboardStats() {
  const [data, setData] = useState({});
  const { setCirleLoading } = useLoading();
  const gradients = [
    "linear-gradient(135deg, #E3F2FD 0%, #BBDEFB 100%)",
    "linear-gradient(135deg, #FFF3E0 0%, #FFE0B2 100%)",
    "linear-gradient(135deg, #E8F5E9 0%, #C8E6C9 100%)",
  ];

  const stats = [
    {
      label: "Total Employees Count",
      value: data?.attendanceSummary?.totalEmployees,
      icon: <PeopleAltIcon />,
    },
    {
      label: "Employees Checked In",
      value: data?.attendanceSummary?.checkedInToday,
      icon: <WorkHistoryIcon />,
    },
    {
      label: "Employees Not Checked In",
      value: data?.attendanceSummary?.notCheckedInToday,
      icon: <CalendarMonthIcon />,
    },
  ];

  const iconColors = ["#1565C0", "#EF6C00", "#2E7D32", "#6A1B9A", "#F9A825"];

  useEffect(() => {
    getDashboardData();
  }, []);

  const getDashboardData = async () => {
    setCirleLoading(true);
    const query = `
      query DashboardQuery{
  branchwiseEmployeeCount {
    branch
    totalEmployees
  }
  attendanceSummary {
    totalEmployees
    checkedInToday
    notCheckedInToday
  }
 
  branchwiseAttendanceSummary {
    branch
    totalEmployees
    checkedInToday
    notCheckedInToday
    employeeDetails {
      empid
      employeeName
      checkIn
      checkOut
    }
  }
  currentMonthHolidays {
    event
    eventDate
  }
  currentWeekoffDays {
    weekoffDays
  }
}
    `;

    try {
      const response = await axios.post(BASEURL, {
        query: query,
      });
      setData(response?.data?.data);
    } catch (error) {
      console.log(error, "error");
    } finally {
      setCirleLoading(false);
    }
  };

  return (
    <DashboardLayout>
      <Grid2 container spacing={2}>
        {stats.map((stat, index) => (
          <Grid2 size={{ xs: 12, sm: 6, md: 4 }} key={index}>
            <div
              style={{
                background: gradients[index % gradients.length],
                borderRadius: "18px",
                padding: "22px",
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                height: "100px",
                width: "100%",
                boxShadow: "0 3px 10px rgba(0,0,0,0.1)",
                border: "1px solid rgba(255,255,255,0.3)",
                transition: "all 0.3s ease",
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = "translateY(-4px)";
                e.currentTarget.style.boxShadow = "0 6px 18px rgba(0,0,0,0.15)";
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = "translateY(0)";
                e.currentTarget.style.boxShadow = "0 3px 10px rgba(0,0,0,0.1)";
              }}
            >
              <div>
                <Typography
                  sx={{
                    fontSize: "15px",
                    fontWeight: 600,
                    color: "#333",
                  }}
                >
                  {stat.label}
                </Typography>
                <Typography
                  sx={{
                    fontSize: "30px",
                    fontWeight: "bold",
                    marginTop: "8px",
                    color: iconColors[index % iconColors.length],
                  }}
                >
                  {stat.value}
                </Typography>
              </div>

              <IconButton
                sx={{
                  backgroundColor: "white",
                  height: "55px",
                  width: "55px",
                  color: iconColors[index % iconColors.length],
                  boxShadow: "0 3px 10px rgba(0,0,0,0.1)",
                }}
              >
                {stat.icon}
              </IconButton>
            </div>
          </Grid2>
        ))}
        {/* 
        <Grid2 container spacing={2} sx={{ mt: 1 }}>
          <Grid2 size={{ xs: 12, md: 6 }}>
            <CustomCalendar data={data} />
          </Grid2>

          <Grid2 size={{ xs: 12, md: 6 }}>
            <SimpleBranchBar data={data} />
          </Grid2>
        </Grid2> */}
        <Grid2 container  >
          <Grid2 size={{ xs: 12, md: 6}}>
            <CustomCalendar data={data} />
          </Grid2>
          <Grid2 size={{ xs: 12, md: 6}}>
            <SimpleBranchBar data={data} />
          </Grid2>
        </Grid2>
      </Grid2>
    </DashboardLayout>
  );
}
